<template>
  <div class="app-container">
	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
		<el-form :inline="true" :model="queryParams">
			<el-form-item label="关键词" prop="keyWord">
			  <el-input v-model="queryParams.keyWord" placeholder="请输入关键词" clearable @keyup.enter.native="handleQuery" />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="small" v-on:click="handleCurrentChange(1)">查询</el-button>
			</el-form-item>
		</el-form>
	</el-col>
    <el-table :data="list"  border>
	  <el-table-column label="用户(ID)" min-width="70" align="center">
	  	<template slot-scope="scope">
	  		<div>{{scope.row.userInfo.nickname}}({{scope.row.userInfo.id}})</div>
	  	</template>
	  </el-table-column>
	  <el-table-column prop="id" label="直播间ID" width="100" align="center">
	  </el-table-column>
	  <el-table-column  prop="categoryName" label="直播分类" min-width="50" align="center">
	  </el-table-column>
	  <el-table-column  prop="roomTitle" label="标题" min-width="50" align="center">
	  </el-table-column>
	  <el-table-column prop="frontImg" label="封面" align="center" width="145">
	  	<template slot-scope="scope">
	  	  <el-popover placement="top-start" title="" trigger="click" v-if="scope.row.frontImg">
	  		<img :src="scope.row.frontImg" alt="" style="width: 500px">
	  		<img slot="reference" :src="scope.row.frontImg" style="width: 50px;height: 50px;object-fit: cover;">
	  	  </el-popover>
	  	</template>
	  </el-table-column>
	  <el-table-column  prop="pkNum" label="pk次数" min-width="50" align="center">
	  </el-table-column>
	  <el-table-column  prop="fansNum" label="粉丝数" min-width="50" align="center">
	  </el-table-column>
	  <el-table-column label="直播状态" min-width="50" align="center">
	  	<template slot-scope="scope">
	  	  <span>{{scope.row.status===1?'直播中' :scope.row.status===3?'已封禁' :'已结束'}}</span>
	  	</template>
	  </el-table-column>
	  <el-table-column label="审核状态" min-width="50" align="center">
	  	<template slot-scope="scope">
	  	  <span>{{scope.row.verifyStatus===0?'审核中' :scope.row.verifyStatus===1?'审核通过' :'审核拒绝'}}</span>
	  	</template>
	  </el-table-column>
	  <el-table-column prop="createTime" label="创建时间" width="150" align="center">
	  	<template slot-scope="scope">
	  	  <span>{{timestampFormat(scope.row.createTime)}}</span>
	  	</template>
	  </el-table-column>
	  <el-table-column label="操作" align="center" width="100">
	    <template slot-scope="scope">
		  <el-popover placement="top-start" title="" trigger="click" content="" @show="handlezuanshiliushuitongji(scope.row.id)" width="800">
			 <div class="box" v-if="data">
				<div class="box-item">
				  <span class="box-item-span1">今日数据</span>
				  <span class="box-item-span">房间流水(花币)：{{data.toDayInfo.chatRoomSum}}</span>
				  <span class="box-item-span">主播收入(积分)：{{data.toDayInfo.zbsr}}</span>
				  <span class="box-item-span">房间开播时长(h)：{{data.toDayInfo.kbSc }}</span>
				  <span class="box-item-span">送礼人数：{{data.toDayInfo.giveNumber }}</span>
				</div>
				<div class="box-item">
				  <span class="box-item-span1">本周数据</span>
				  <span class="box-item-span">房间流水(花币)：{{data.currentWeekInfo.chatRoomSum}}</span>
				  <span class="box-item-span">主播收入(积分)：{{data.currentWeekInfo.zbsr}}</span>
				  <span class="box-item-span">房间开播时长(h)：{{data.currentWeekInfo.kbSc }}</span>
				  <span class="box-item-span">送礼人数：{{data.currentWeekInfo.giveNumber }}</span>
				</div>
				<div class="box-item1">
				  <span class="box-item-span1">本月数据</span>
				  <span class="box-item-span">房间流水(花币)：{{data.currentMonthInfo.chatRoomSum}}</span>
				  <span class="box-item-span">主播收入(积分)：{{data.currentMonthInfo.zbsr}}</span>
				  <span class="box-item-span">房间开播时长(h)：{{data.currentMonthInfo.kbSc }}</span>
				  <span class="box-item-span">送礼人数：{{data.currentMonthInfo.giveNumber }}</span>
				</div>
			  <div class="box-item1">
				<span class="box-item-span1">上月数据</span>
				<span class="box-item-span">房间流水(花币)：{{data.lastMonthInfo.chatRoomSum}}</span>
				<span class="box-item-span">主播收入(积分)：{{data.lastMonthInfo.zbsr}}</span>
				<span class="box-item-span">房间开播时长(h)：{{data.lastMonthInfo.kbSc }}</span>
				<span class="box-item-span">送礼人数：{{data.lastMonthInfo.giveNumber }}</span>
			  </div>
			  </div>
			  <el-button size="mini" type="text" icon="el-icon-view" slot="reference">房间统计</el-button>
			</el-popover>
	    </template>
	  </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar" v-show="total > 0">
    	<el-pagination background layout="prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="queryParams.size" :total="total" style="float:right;">
    	</el-pagination>
    </el-col>
  </div>
</template>

<script>
import { getGuildChatRoomList,getGuildChatRoomStatisticsInfo } from "@/api/gonghui";
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 参数表格数据
      list: [],
      // 弹出层标题
      title: "房间统计",
      // 是否显示弹出层
      open: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        page:1,
		size:10,
		guildId:null,
		keyWord:null
      },
      // 表单参数
      form: {
       
      },
	  data:'',
      // 表单校验
      rules: {
    
      }
    };
  },
  created() {
	const data = JSON.parse(Cookies.get('user'))
	this.queryParams.guildId = data.guildId
    this.getList();
  },
  methods: {
	zeroize(num) {
		return (String(num).length == 1 ? "0" : "") + num;
	},
	timestampFormat(timestamp) {
		var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
		var timestampDiff = curTimestamp - parseInt(timestamp / 1000); // 参数时间戳与当前时间戳相差秒数
		var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
		var tmDate = new Date(parseInt(timestamp / 1000) * 1000); // 参数时间戳转换成的日期对象
		var Y = tmDate.getFullYear(),
		m = tmDate.getMonth() + 1,
		d = tmDate.getDate();
		var H = tmDate.getHours(),
		i = tmDate.getMinutes(),
		s = tmDate.getSeconds();
		return (Y + "-" + this.zeroize(m) + "-" + this.zeroize(d) + " " + this.zeroize(H) + ":" + this.zeroize(i) + ":" + this.zeroize(s));
	},
    /** 入会审批 */
	getList() {
	  this.loading = true;
	  getGuildChatRoomList(this.queryParams).then(response => {
	    this.loading = false
		this.list = response.rows
		console.log(this.list)
	    this.total = response.total;
	  });
	},
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
		logo:undefined,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleCurrentChange(val) {
		this.queryParams.page = val;
		this.getList();
	},
	//流水统计
	handlezuanshiliushuitongji(id){
	  this.data = ''
	  this.chatRoomId = id
	  const data = JSON.parse(Cookies.get('user'))
	  let params = {
	    chatRoomId:id,
	    guildId:data.guildId
	  }
	  getGuildChatRoomStatisticsInfo(params).then(response => {
	    this.data = response.data
	  })
	},

  }
};
</script>
<style scoped>
	.el-table td, .el-table th{
		padding: 6px 0px;
	}
	.el-table{
		font-size: 12px;
	}
	.el-button+.el-button{
		margin-left: 0px;
	}
	.el-table th.gutter{
        display: table-cell!important;
    }
	.box{
	  display: flex;
	  flex-direction: row;
	  justify-content: space-between;
	}
	.box-item{
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  flex: 1;
	  border-right: 0.5px solid #efefef;
	}
	.box-item1{
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  flex: 1;
	}
	.box-item-span{
	  font-size: 14px;
	  font-weight: 400;
	  line-height: 18px;
	  color: #000;
	  padding-top: 10px;
	}
	.box-item-span1{
	  font-size: 16px;
	  font-weight: bold;
	  line-height: 18px;
	  color: #000;
	}
</style>


// WEBPACK FOOTER //
// fangjiantongji.vue?92b6f5ee